import React, { useState } from 'react';
import rent15 from '../img/rent/1.5 тонны.png'; // Импортируем изображения для аренды
import rent2 from '../img/rent/2 тонны.png';
import rent25 from '../img/rent/2.5 тонны.png';
import rent3 from '../img/rent/3 тонны.png';
import rent35 from '../img/rent/3.5 тонны.png';
import rent4 from '../img/rent/4 тонны.png';
import rent45 from '../img/rent/4.5 тонны.png';
import rent5 from '../img/rent/5 тонны.png';
import { Button, Container } from 'react-bootstrap';
import '../css/rent.css'
import '../css/forms.css'
import '../css/popup.css'
import Ask from "../components/Ask"


const Rent = () => {
    const [isLoading, setIsLoading] = useState(false); // Состояние для управления загрузкой
    const [isPopupOpen, setIsPopupOpen] = useState(false); // Состояние для управления попапом
    const [currentPopupImage, setCurrentPopupImage] = useState(null); // Сохраняем, какой попап открыть
    // Функция для открытия попапа
    const openPopup = (image) => {
      setCurrentPopupImage(image);
      setIsPopupOpen(true);
    };
  
    // Функция для закрытия попапа
    const closePopup = () => {
      setIsPopupOpen(false);
      setCurrentPopupImage(null);
    };
    const forkliftData = [
      { img: rent15, title: "Погрузчик 1.5 тонны", alt: "1.5 тонны" },
      { img: rent2, title: "Погрузчик 2 тонны", alt: "2 тонны" },
      { img: rent25, title: "Погрузчик 2.5 тонны", alt: "2.5 тонны" },
      { img: rent3, title: "Погрузчик 3 тонны", alt: "3 тонны" },
      { img: rent35, title: "Погрузчик 3.5 тонны", alt: "3.5 тонны" },
      { img: rent4, title: "Погрузчик 4 тонны", alt: "4 тонны" },
      { img: rent45, title: "Погрузчик 4.5 тонны", alt: "4.5 тонны" },
      { img: rent5, title: "Погрузчик 5 тонн", alt: "5 тонн" },
    ];
    // Обработка отправки формы
    const handleSubmit = async (e) => {
      e.preventDefault();
      setIsLoading(true); // Устанавливаем состояние загрузки
      const formData = new FormData(e.target);
      const name = formData.get('name');
      const tel = formData.get('tel');
      const email = formData.get('email');
      const forklift = currentPopupImage.split('/').pop().split('.')[0];
    
      // Регулярные выражения для проверки
      const phoneRegex = /^\+?[78][-(]?\d{3}\)?[-]?\d{3}[-]?\d{2}[-]?\d{2}$/; // Для российских номеров
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
      // Проверка данных
      if (!name.trim()) {
        alert('Пожалуйста, введите ваше имя.');
        setIsLoading(false); // Сбрасываем состояние загрузки
        return;
      }
      if (!phoneRegex.test(tel)) {
        alert('Пожалуйста, введите корректный номер телефона.');
        setIsLoading(false); // Сбрасываем состояние загрузки
        return;
      }
      if (!emailRegex.test(email)) {
        alert('Пожалуйста, введите корректный адрес электронной почты.');
        setIsLoading(false); // Сбрасываем состояние загрузки
        return;
      }
    
      const data = { name, tel, email, forklift, type: 'rent' };
    
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}api/send-email`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        });
    
        if (response.ok) {
          alert('Заявка успешно отправлена! Менеджер свяжется с вами в ближайшее время.');
          closePopup();
        } else {
          alert('Ошибка при отправке заявки.');
        }
      } catch (error) {
        console.error('Ошибка:', error);
        alert('Произошла ошибка при отправке.');
      } finally {
        setIsLoading(false); // Сбрасываем состояние загрузки
      }
      
    };

  return (
    <Container style={{ maxWidth: '1200px' }}>
            <h1 className="section-title">Погрузчики в аренду</h1>
      <div className="container-sm">
        <div className="row">
          {forkliftData.map((forklift, index) => (
            <div key={index} className="col-lg-3 col-md-6 col-sm-12">
              <div className="forklift-card">
                <img 
                  src={forklift.img} 
                  alt={forklift.alt} 
                  className="forklift-image"
                />
                <h3 className="forklift-title">{forklift.title}</h3>
                <button
                  className="rent-button"
                  onClick={(e) => {
                    e.preventDefault();
                    openPopup(forklift.img);
                  }}
                >
                  Оставить заявку
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Попап */}
      {isPopupOpen && (
        <div className={`pop_up ${isPopupOpen ? 'active' : ''}`}>
          <div className="pop_up_container">
            <div className="pop_up_body">
              <p>Заказать аренду</p>
              <form className="some-form" id="some-form" onSubmit={handleSubmit}>
                <input type="text" name="name" placeholder="Ваше имя" />
                <input type="tel" name="tel" placeholder="Ваш телефон" />
                <input type="email" name="email" placeholder="Ваша почта" />
                <div className="d-grid gap-2">
                  <Button
                    type="submit"
                    className="button_rent"
                    variant="custom"
                    size="lg"
                    disabled={isLoading} // Отключаем кнопку во время загрузки
                  >
                    {isLoading ? 'Загрузка...' : 'Отправить заявку'}
                  </Button>
              </div>
              </form>
              <div className="pop_up_close" onClick={closePopup}>✖</div>
            </div>
          </div>
        </div>
      )}
      <div className="info-section">
        <h2 className="section-title">О наших услугах</h2>
        <div className="row">
          <div className="col-md-6">
            <h3 style={{ marginBottom: '15px' }}>
              Широкий выбор техники
            </h3>
            <p>
              Мы предоставляем в аренду вилочные погрузчики различной грузоподъемности и назначения.
              Все погрузчики проходят регулярное техническое обслуживание и готовы к работе.
            </p>
          </div>
          <div className="col-md-6">
            <h3 style={{ marginBottom: '15px' }}>
              Работаем по всей России
            </h3>
            <p>
              Мы работаем с клиентами по всей России и готовы доставить погрузчик в любую точку 
              Свердловской области. Гарантируем высокое качество услуг и индивидуальный подход.
            </p>
          </div>
        </div>
      </div>
      <Ask />
    </Container>
  );
}

export default Rent;